import React from 'react';
import { Coffee } from 'lucide-react';

const Footer = () => {
  return (
    <footer data-component-path="client/src/components/Footer.jsx" data-component-line="6:5" data-component-id="client/src/components/Footer.jsx:6:5" className="bg-brown py-12">
      <div data-component-path="client/src/components/Footer.jsx" data-component-line="7:7" data-component-id="client/src/components/Footer.jsx:7:7" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-path="client/src/components/Footer.jsx" data-component-line="8:9" data-component-id="client/src/components/Footer.jsx:8:9" className="flex flex-col items-center gap-6">
          <div data-component-path="client/src/components/Footer.jsx" data-component-line="9:11" data-component-id="client/src/components/Footer.jsx:9:11" className="flex items-center gap-3">
            <Coffee data-component-path="client/src/components/Footer.jsx" data-component-line="10:13" data-component-id="client/src/components/Footer.jsx:10:13" className="w-8 h-8 text-copper flex-shrink-0" />
            <span data-component-path="client/src/components/Footer.jsx" data-component-line="11:13" data-component-id="client/src/components/Footer.jsx:11:13" className="hero-title text-2xl text-cream">
              The Ember & Oak
            </span>
          </div>
          
          <div data-component-path="client/src/components/Footer.jsx" data-component-line="16:11" data-component-id="client/src/components/Footer.jsx:16:11" className="text-center">
            <p data-component-path="client/src/components/Footer.jsx" data-component-line="17:13" data-component-id="client/src/components/Footer.jsx:17:13" className="text-cream/80 mb-2">
              Open Daily: 7:00 AM - 10:00 PM
            </p>
            <p data-component-path="client/src/components/Footer.jsx" data-component-line="20:13" data-component-id="client/src/components/Footer.jsx:20:13" className="text-cream/60 text-sm">
              © 2025 The Ember & Oak. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;